import { computed, inject, InjectionToken } from '@angular/core';
import { MenuItemBase, uiFeature } from '@mapa/ngx';
import { Store } from '@ngrx/store';

const itemMap: Record<string, MenuItemBase> = {
  'home': {
    link: '/',
    text: 'Home'
  },
  'about': {
    link: '/about',
    text: 'About',
    children: [
      {
        link: '/about/the-practice',
        text: 'The Practice'
      },
      {
        link: '/about/finding-my-calling',
        text: 'Finding My Calling'
      },
    ]
  },
  'contact-us': {
    link: '/contact-us',
    text: 'Contact Us'
  },
  'portfolio': {
    link: '/portfolio',
    text: 'Portfolio'
  },
  'services': {
    link: '/services',
    text: 'Services'
  },
  'how-we-work': {
    link: '/how-we-work',
    text: 'How We Work',
    children: [
      {
        link: '/how-we-work/design-approach',
        text: 'Design Approach'
      },
      {
        link: '/how-we-work/services',
        text: 'Services'
      },
      {
        link: '/how-we-work/design-process',
        text: 'Design Process'
      },
      {
        link: '/how-we-work/design-fees',
        text: 'Design Fees'
      },
    ]
  }
};



export const publicMenu = [
  itemMap['about'],
  itemMap['how-we-work'],
  itemMap['portfolio'],
  itemMap['contact-us'],
];

export const PUBLIC_MENU = new InjectionToken('PUBLIC_MENU', {
  providedIn: 'root',
  factory: () => {
    const store = inject(Store);
    const screenSize$ = store.selectSignal(uiFeature.selectScreenSize);

    // where the public menu will split between horizontal and vertical
    // items before the split is
    const split$ = computed(() => {
      const screenSize = screenSize$();

      switch (screenSize) {
        case 'xs':
        case 'sm':
        case 'md':
        case 'lg':
        case 'xl':
        case '2xl':
        case '3xl':
        case '4xl': return 'vertical';
        case '5xl':
        case '6xl':
        case '7xl':
        case '8xl':
        case '9xl':
        case '10xl': return 'horizontal';
      }
    });

    const items$ = computed(() => {
      let vertical: MenuItemBase[];
      let horizontal: MenuItemBase[];

      const split = split$();

      if (split === 'horizontal') {
        vertical = [];
        horizontal = publicMenu;
      }
      else if (split === 'vertical') {
        vertical = publicMenu;
        horizontal = [];
      }
      else {
        vertical = publicMenu.slice(split);
        horizontal = publicMenu.slice(0, split);
      }

      return { vertical, horizontal } as const;
    });

    return items$;
  }
});

export const footerMenu = {
  quickLinks: [
    itemMap['about'],
    itemMap['portfolio'],
    itemMap['contact-us']
  ],
  howWeWork: itemMap['how-we-work'].children
} as const;


